module.exports = __webpack_public_path__ + "static/media/3.20.52226475.png";